// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: 
  {
    apiKey: "AIzaSyBsEP0cb3hn7xg7TpURArA7q5kype32MxQ",
    authDomain: "bi-iodigital.firebaseapp.com",
    databaseURL: "https://bi-iodigital.firebaseio.com",
    projectId: "bi-iodigital",
    storageBucket: "bi-iodigital.appspot.com",
    messagingSenderId: "53990796195"

    //backup

    // apiKey: "AIzaSyA7ledbWB_Rx30ttm1TH_5L5YDxFwV3s1k",
    // authDomain: "backup-2ecc3.firebaseapp.com",
    // databaseURL: "https://backup-2ecc3.firebaseio.com",
    // projectId: "backup-2ecc3",
    // storageBucket: "gs://backup-2ecc3.appspot.com/",
    // messagingSenderId: "43593403203"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts